<ng-container *ngIf="ready == false">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<ng-container *ngIf="ready">

    <ng-container *ngIf="show">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>

    <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="true" [hasButton]="true"
        [actionsTemplate]="actionsButtons" [headerActionsTemplate]="headerActionsButtons" [hasMonthFilter]="true">
    </app-table>

    <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
            <ul class="custom-class">
                <li (click)="goInvoice(uid)">
                    <a>
                        <mat-icon>cloud_done</mat-icon> Ver Gasto
                    </a>
                </li>
                <li (click)="goFile(uid)">
                    <a>
                        <mat-icon>cloud_done</mat-icon> Ver Fichero
                    </a>
                </li>
            </ul>
        </ng-container>
    </ng-template>

    <div class="rowList text-center">
        <ng-container>
            <br />
            <p>Páginas OCR utilizadas de tu cuota anual <strong>{{pagesUsed}}/{{pagesTotal}}</strong>
                <ng-container *ngIf="ocrWindowEnd"> · se renueva el {{ocrWindowEnd | date:'dd/MM/yyyy'}}</ng-container>
            </p>
            <p *ngIf="creditPages > 0">Páginas extra compradas disponibles <strong>{{creditPages}}</strong></p>
        </ng-container>
    </div>

    <ng-container *ngIf="empty">
        <div class="text-center">
            <img src="assets/icons/factura.svg" class="invoiceImageInvoice">
            <p style="color: #9e9e9e">No tiene ninguna conversión OCR.</p>
        </div>
    </ng-container>
</ng-container>
